import { preloadTopNavigation } from './preloadTopNavigation.ts';

export function preloadAppNavigation(): Promise<void | any[] | Error[]> {
	return preloadTopNavigation();
}
